// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__11fkx","detailsBorder":"styles_detailsBorder__2-mFz"};